<template>
  <IconHourGlass class="text-white bg-yellow rounded"/>
</template>

<script>
import IconHourGlass from "@/components/icons/IconHourGlass";

export default {
  name: "StatusPending",
  components: {IconHourGlass}
}
</script>